import React, { Component } from 'react';
import Editable from '../Editable/Editable';
import IV from '../InputValidation/InputValidation';
import ISocialComponent, { socialMedia, TSocialComponent } from './ISocialComponent';


const isEqual = require('lodash.isequal');
import * as style from './SocialComponentStyles.module.scss'
import * as appStyle from '../../AppStyle.module.scss';

const socials: string[] = [
  'Facebook',
  'Twitter',
  'Linkedin',
  'Telegram',
  'Github',
];

export default class SocialComponent extends Component<ISocialComponent, TSocialComponent> {

  state: TSocialComponent = {
    data: this.props.socials || [],
    excluded: this.props.socials ? this.props.socials.map(el => Object.keys(el)[0]) : [],
  };

  UNSAFE_componentWillReceiveProps(nextProps: ISocialComponent) {
    if (nextProps.socials && !isEqual(nextProps.socials, this.state.data)) {
      const data = nextProps.socials.map((elem):socialMedia => {
        const tmp: socialMedia = {};
        const e = Object.entries(elem)[0];
        tmp[e[0]] = e[1].indexOf('//') > -1 ? e[1] : 'http://' + e[1];
        return tmp;
      });
      this.setState({
        data: data,
        excluded: nextProps.socials ? nextProps.socials.map(el => Object.keys(el)[0]) : [],
      });
    }
  }

  componentDidUpdate(prevProps: ISocialComponent, prevState: TSocialComponent) {
    const equal = isEqual(prevState.data, this.state.data);

    if (!equal && this.props.editMode && this.props.getSocials) {
      this.props.getSocials(this.state.data);
    }
  }

  renderSelect() {
    return (
      <div className={style.wrapper}>
        <label className={style.label}>
          <select
            className={style.select}
            onChange={e => this.selectChange(e)}
            defaultValue={''}
          >
            <option
              disabled={false}
              hidden={false}
              value={''}
            >
              Select Social Media
            </option>
            {socials.map((social) => {
              return (
                !this.state.excluded.includes(social.toLowerCase()) ?
                  <option key={social} value={social}>
                    {social}
                  </option> :
                  null
              );
            })}
          </select>
        </label>
      </div>
    );
  }

  selectChange(e: React.BaseSyntheticEvent) {
    const value = e.target.value.toLowerCase();
    const web = value === 'telegram' ? 'http://telegram.org' : `http://${value}.com`;

    const alreadySelected = this.state.data.filter((social) => {
      if (Object.keys(social).includes(value)) {
        return social;
      }
      return;
    });

    if (alreadySelected.length || value === undefined) return;

    this.setState({
      data: [...this.state.data, { [value]: web }],
      excluded: [...this.state.excluded, value],
    });
  }

  removeSocial(selectedSocial:string) {
    this.setState({
      data: this.state.data.filter(
        (el) => {
          if (Object.keys(el).includes(selectedSocial)) {
            return ;
          }
          return el;
        }
      ),
      excluded: this.state.excluded.filter(
        (el) => {return el.toLowerCase() !== selectedSocial.toLowerCase();}
      ),
    });
  }

  renderEditSocialList() {
    return (
      <ul className={style.socialsEditableList}>
        {this.state.data.map((social, index) => {
          return (
            <li key={Object.keys(social)[0]} className={style.socialsEditableListElement}>
              <span className={style.socialsCircle}>
                <i className={`fa fa-${Object.keys(social)[0].toLowerCase()}`} />
              </span>
              <p>{Object.keys(social)[0]}</p>
              {this.props.validation ? (
                <IV type="URL" value={Object.values(social)[0]} dispatch={this.props.dispatch}>
                  <Editable type="input" _this={this} name={Object.keys(social)[0].toLowerCase()} />
                </IV>
              ) : (
                <Editable type="input" _this={this} name={Object.keys(social)[0].toLowerCase()} />
              )}
              <button
                className={appStyle.cancelButton}
                onClick={() => this.removeSocial(Object.keys(social)[0])}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  renderSocialList() {
    return this.state.data.length > 0 ? (
      <ul className={style.socialsList}>
        {this.state.data.map((social, index) => {
          return (
            <li key={index} className={style.socialsListElement}>
              <a
                href={Object.values(social)[0]}
                target="_blank"
                className={style.socialsCircle}
                rel="noopener noreferrer"
              >
                <i className={`fa fa-${Object.keys(social)[0].toLowerCase()}`} />
              </a>
            </li>
          );
        })}
      </ul>
    ) : null;
  }

  renderEditMode() {
    return (
      <React.Fragment>
        {this.renderSelect()}
        {this.renderEditSocialList()}
      </React.Fragment>
    );
  }

  renderComponent() {
    let resultHtml = this.renderSocialList();

    if (this.props.editMode) {
      resultHtml = this.renderEditMode();
    }
    return resultHtml;
  }

  render() {
    return (
      <React.Fragment>
        {this.renderComponent()}
      </React.Fragment>
    );
  }
}
